export default import.meta.ROLLDOWN_FILE_URL_SlCwKFEpiqWwLzUj_Ju8hw